import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { IndDisplayFormAffiliationViewDataModel } from '../../../interfaces/dynamic-form/ind-display-form-affiliation-view-data.interface';

@Component({
  selector: 'ind-affiliations-card',
  templateUrl: 'ind-affiliations-card.html',
  styleUrls: ['ind-affiliations-card.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IndAffiliationsCardComponent {
  @Input() viewData: IndDisplayFormAffiliationViewDataModel;

  constructor() {}

  ngOnInit() {
  }
  onContentClick(event) {
    if (this.viewData?.clickHandler) {
      this.viewData.clickHandler(this.viewData.id, event);
    }
  }

  trackById(index: number, item: any) { return item?.id || item?.ID || index; }
}
